import template from './branch_funding_source.all.html';
import controller from './branch_funding_source.all.controller';
import './branch_funding_source.all.scss';

let branchFundingSourceallComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },

  template,
  controller
};

export default branchFundingSourceallComponent;


// WEBPACK FOOTER //
// ./client/app/components/branch_funding_source/all/branch_funding_source.all.component.js